import React from "react";
import "./Banner.scss";
const Banner = (props) => {
    const {
        headline,
        subheadline,
        features,
        buttonText,
        buttonLink,
        image_url,
    } = props;
    return (
        <a href={buttonLink} className="banner--tile">
            <picture>
                <img src={image_url} alt="" title="" />
            </picture>
            <div className="banner--tile-content">
                <h3 className="banner--tile-headline">{headline}</h3>
                <p className="banner--tile-subheadline">{subheadline}</p>
                <ul className="banner--tile-list">
                    {features.map((feature, index) => {
                        return (
                            <li key={index}>
                                <i className="fal fa-check-circle"></i>
                                <span>{feature}</span>
                            </li>
                        );
                    })}
                </ul>
                <div className="banner--tile-button">{buttonText}</div>
            </div>
        </a>
    );
};

export default Banner;
